import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=57dbe33c&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=57dbe33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dbe33c",
  null
  
)

export default component.exports